module.exports = __webpack_public_path__ + "img/MB_lobby.dae134e7.jpg";